export const getUniqueTags = (data: TDataTable): string[] => {
  const tagList: string[] = [];
  data.forEach(({ stack }) => {
    const tags: string[] = stack
      .split(",")
      .filter((item: string) => item.trim().length > 0);

    tags.forEach((tagNew) => {
      const isNonUnique = tagList.some((tag) => tag.trim() === tagNew.trim());
      if (!isNonUnique) tagList.push(tagNew.trim());
    });
  });

  return tagList;
};
